"use client";
import { Check as e } from "../Icon/icons.gen.mjs";
import "../../../utils/iconDefaults.mjs";
import { forwardRef as t } from "react";
import { jsx as n } from "react/jsx-runtime";
import * as r from "@radix-ui/react-checkbox";
//#region src/components/atoms/Checkbox/Checkbox.tsx
var i = t((e, t) => /* @__PURE__ */ n(r.Root, {
	"data-slot": "checkbox",
	...e,
	ref: t
}));
i.displayName = "CheckboxRoot";
var a = t(({ children: t, ...i }, a) => /* @__PURE__ */ n(r.Indicator, {
	"data-slot": "checkbox-indicator",
	...i,
	ref: a,
	children: t ?? /* @__PURE__ */ n(e, {
		"data-slot": "checkbox-check-icon",
		"aria-hidden": "true",
		className: "size-4 shrink-0 [&_path]:fill-current"
	})
}));
a.displayName = "CheckboxIndicator";
//#endregion
export { a as CheckboxIndicator, i as CheckboxRoot };
